import Form from "../../components/form/form";
import Joi from "joi-browser";
import React from "react";
import consulingService from "../../services/consulingService";
import { toast } from 'react-toastify';
import "./consuling.css";
import Page from "../../components/page/page";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import ReCAPTCHA from "react-google-recaptcha";
import { Fragment } from "react";
import { getProvinces } from "../../constants/provinces-constant";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";


export default class consuling extends Form {

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            isLoading: false,
            captchaRef: "",
            partRequest: false,
            model: "",
            proviences: [...getProvinces()],
            isProviencesSelected: false,
            selectedProvience: "null"
        };
    }
    state = {
        data: {
            Requester: "",
            CompanyName: "",
            MobileNumber: "",
            CompanyPhone: "",
            ModelDetail: "",
            RequestDescription: "",
            Province: "",
            ProvinceId: "",
        },
        errors: {},
    };

    schema = {
        Requester: Joi.string().required().error(new Error("نام درخواست دهنده")),
        MobileNumber: Joi.string().required().error(new Error("شماره همراه")),
        RequestDescription: Joi.string().required().error(new Error("شرح درخواست")),
        province: Joi.string().required().error(new Error("استان محل نصب")),
        provinceId: Joi.string().required().error(new Error("استان محل نصب")),
        CompanyName: Joi.string().allow(null, ""),
        CompanyPhone: Joi.string().allow(null, ""),
        ModelDetail: Joi.string().allow(null, ""),
    };

    onChange = async (value) => {
        this.setState({ captchaRef: value });
    }

    doSubmit = async () => {
        const { data } = this.state;
        try {
            if (!this.state.captchaRef) {
                toast.error("کپچا الزامی است");
                const isLoading = false;
                this.setState({ isLoading: isLoading });
                return;
            }
            var result = await consulingService.RegisterPartRequest(
                data.Requester,
                data.CompanyName,
                data.MobileNumber,
                data.CompanyPhone,
                this.props.model,
                data.RequestDescription,
                data.provinceId,
                data.province,
                this.state.captchaRef
            );

            const isLoading = false;
            const showSuccessMessage = true;
            this.setState({ isLoading: isLoading });
            this.setState({ showSuccessMessage: showSuccessMessage });

        } catch (ex) {
            if (ex.code !== "ERR_NETWORK") {
                toast.error(ex.response.data.Message);
            }
            const isLoading = false;
            this.setState({ isLoading: isLoading });
        }
    };

    handleProviencesSelect = province => {
        this.setState({ selectedProvience: province.value }, () => {
            this.state.data.province = province.label;
            this.state.data.provinceId = province.value;
        });
    };

    render() {
        return (
            <Page>
                <Header />
                <section className="container consuling">
                    <div className="row hrow headbox-dark">
                        <h3 className="title">ثبت درخواست</h3>
                        {this.props.partRequest &&
                            <span className="subtitle">
                                ثبت درخواست کالا
                            </span>
                        }
                        {!this.props.partRequest &&
                            <span className="subtitle">
                                ثبت درخواست مشاوره و راهنمایی و خدمات
                            </span>
                        }
                    </div>

                    <div className="row">
                        <form onSubmit={this.handleSubmit} action="/">
                            <div className="mb-4 mt-3">
                                {this.renderInput(
                                    "Requester",
                                    "",
                                    "نام درخواست دهنده",
                                    "text",
                                    "form-control form-control-lg",
                                    "true"
                                )}
                            </div>
                            <div className="mb-4">
                                {this.renderInput(
                                    "CompanyName",
                                    "",
                                    "شرکت",
                                    "text",
                                    "form-control form-control-lg",
                                    "false"
                                )}
                            </div>
                            <div className="mb-4">
                                {this.renderInput(
                                    "MobileNumber",
                                    "",
                                    "شماره همراه",
                                    "text",
                                    "form-control form-control-lg",
                                    "true"
                                )}
                            </div>
                            <div className="mb-4">
                                {this.renderInput(
                                    "CompanyPhone",
                                    "",
                                    "تلفن تماس شرکت",
                                    "text",
                                    "form-control form-control-lg",
                                    "false"
                                )}
                            </div>
                            <div className="mb-4 mt-3">
                                <small style={{ color: "red" }}>اجباری</small>
                                <DropDownWhiteStyle
                                    items={this.state.proviences}
                                    placeholder="استان محل نصب"
                                    onItemSelect={this.handleProviencesSelect}
                                />
                            </div>
                            <div className="mb-4">
                                <label
                                    htmlFor="exampleFormControlTextarea1"
                                    className="visually-hidden form-label"
                                >
                                    شرح موضوع
                                </label>
                                {this.renderTextArea(
                                    "RequestDescription",
                                    "شرح درخواست",
                                    "form-control form-control-lg",
                                    3,
                                    "true"
                                )}
                            </div>
                            <div className="d-flex justify-content-center m-4" >
                                <ReCAPTCHA
                                    sitekey={process.env.REACT_APP_SITE_KEY}
                                    onChange={this.onChange}
                                />
                            </div>
                            {this.props.partRequest &&
                                <Fragment>
                                <h5 className="d-flex justify-content-center">
                                    مدل کالای درخواستی شما :
                                </h5>
                                <h1 className="suggestedModel d-flex justify-content-center m-2">
                                    {this.props.model}
                                </h1>
                                </Fragment>
                            }
                            <div className="d-grid mb-4">
                                {this.renderButtonWithSpinner("ثبت درخواست", "btn btn-primary")}
                            </div>
                        </form>
                    </div>
                </section>
                <Footer />
            </Page>
        );
    }
}